var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4462 13.9861C15.2608 14.0842 15.0475 14.1724 14.8062 14.2507C14.4222 14.368 13.8453 14.4267 13.3333 14.4267V12.2187C13.7387 12.2187 14.2409 12.1547 14.5822 12.0267C14.9342 11.8987 15.2329 11.7173 15.4782 11.4827C15.7236 11.248 15.8942 10.976 15.9902 10.6667H17.7822V21.5627H15.4462V13.9861Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM25.3333 16C25.3333 21.1547 21.1547 25.3333 16 25.3333C10.8453 25.3333 6.66667 21.1547 6.66667 16C6.66667 10.8453 10.8453 6.66667 16 6.66667C21.1547 6.66667 25.3333 10.8453 25.3333 16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOne);
export default __webpack_public_path__ + "static/media/number-one.494e22565d3c92f47e2bcf8ca85b81d0.svg";
export { ForwardRef as ReactComponent };